/**
 * Risk Level Enum
 */
export var RiskLevel;
(function (RiskLevel) {
    RiskLevel[RiskLevel["Low"] = 0] = "Low";
    RiskLevel[RiskLevel["Medium"] = 1] = "Medium";
    RiskLevel[RiskLevel["High"] = 2] = "High";
    RiskLevel[RiskLevel["Critical"] = 3] = "Critical";
})(RiskLevel || (RiskLevel = {}));
//# sourceMappingURL=Project.js.map